





























import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import moment from 'moment'

export class LogEntry {
    public id = ''
    public message = ''
    public readonly tempId = _.uniqueId('log_')
    public createdAt = new Date()

    public static deserialize (data: KeyValuePair) {
        const entry = new this()
        entry.id =  data.id
        entry.message =  data.message
        entry.createdAt = new Date(data.createdAt)

        return entry
    }
}

@Component
export default class EventViewer extends Vue {
    public logCount = 0
    public connected = false
    public logs: LogEntry[] = []
    public headers = [
        { text: 'Id', value: 'id'},
        { text: 'Fecha', value: 'createdAt', width: '200px'},
        { text: 'Mensaje', value: 'message'},
    ]

    public fancyDate (date: Date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }

    public created () {
        const ws = new WebSocket('ws://127.0.0.1:9500')
        ws.addEventListener('open', () => this.connected = true)

        ws.addEventListener('message', (message) => {
            const entry = JSON.parse(message.data).payload
            if (!entry) {
                return
            }

            // Limita a 200 el número de registros
            if (this.logs.length === 200) {
                this.logs.pop()
            }

            this.logs.unshift(LogEntry.deserialize(entry))
            this.logCount++
        })
    }
}
